<div
  class="layout-wrapper"
  [dir]="currentLanguage() === 'ar' ? 'rtl' : 'ltr'"
>

  <mat-sidenav-container
    class="sidenav-container"
  >

    <!-- ===================================================== -->
    <!-- SIDENAV -->
    <!-- ===================================================== -->

    <mat-sidenav
      #drawer
      class="sidenav"
      fixedInViewport
      [attr.role]="isMobile() ? 'dialog' : 'navigation'"
      [mode]="isMobile() ? 'over' : 'side'"
      [opened]="!isMobile()"
    >

      <!-- BRAND -->

      <div class="mobile-brand">

        <div class="mobile-brand-icon">
       
<img src="assets/images/whitelogo.png" alt="Logo" />

      
        </div>


      </div>


      <!-- MENU -->

      <mat-nav-list>

        <a
          mat-list-item
          routerLink="/admin/dashboard"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          (click)="closeMobileDrawer(drawer)"
        >

          <mat-icon matListItemIcon>
            home
          </mat-icon>

          <span matListItemTitle class="item">
            {{ 'nav.home' | translate }}
          </span>

        </a>


        <a
          mat-list-item
          routerLink="/admin/products"
          routerLinkActive="active"
          (click)="closeMobileDrawer(drawer)"
        >

          <mat-icon matListItemIcon>
            inventory_2
          </mat-icon>

          <span matListItemTitle class="item">
            {{ 'nav.products' | translate }}
          </span>

        </a>


        <a
          mat-list-item
          routerLink="/admin/categories"
          routerLinkActive="active"
          (click)="closeMobileDrawer(drawer)"
        >

          <mat-icon matListItemIcon>
            category
          </mat-icon>

          <span matListItemTitle class="item">
            {{ 'nav.categories' | translate }}
          </span>

        </a>


        <a
          mat-list-item
          routerLink="/admin/subCategories"
          routerLinkActive="active"
          (click)="closeMobileDrawer(drawer)"
        >

          <mat-icon matListItemIcon>
            subject
          </mat-icon>

          <span matListItemTitle class="item">
            {{ 'nav.subCategories' | translate }}
          </span>

        </a>


        <a
          mat-list-item
          routerLink="/admin/brand"
          routerLinkActive="active"
          (click)="closeMobileDrawer(drawer)"
        >

          <mat-icon matListItemIcon>
            storefront
          </mat-icon>

          <span matListItemTitle class="item">
            {{ 'nav.brands' | translate }}
          </span>

        </a>


        <a
          mat-list-item
          routerLink="/admin/users"
          routerLinkActive="active"
          (click)="closeMobileDrawer(drawer)"
        >

          <mat-icon matListItemIcon>
            supervised_user_circle
          </mat-icon>

          <span matListItemTitle class="item">
            {{ 'nav.users' | translate }}
          </span>

        </a>


        <a
          mat-list-item
          routerLink="/admin/orders"
          routerLinkActive="active"
          (click)="closeMobileDrawer(drawer)"
        >

          <mat-icon matListItemIcon>
            receipt_long
          </mat-icon>

          <span matListItemTitle class="item">
            {{ 'nav.orders' | translate }}
          </span>

        </a>
<a
          mat-list-item
          routerLink="/admin/slider"
          routerLinkActive="active"
          (click)="closeMobileDrawer(drawer)"
        >

          <mat-icon matListItemIcon>
            image
          </mat-icon>

          <span matListItemTitle class="item">
            {{ 'nav.slider' | translate }}
          </span>

        </a>

        <mat-divider></mat-divider>


        <!-- LOGIN -->

        @if (!isLoggedIn()) {

          <a
            mat-list-item
            routerLink="/login"
            routerLinkActive="active"
            (click)="closeMobileDrawer(drawer)"
          >

            <mat-icon matListItemIcon>
              login
            </mat-icon>

            <span matListItemTitle class="item">
              {{ 'common.login' | translate }}
            </span>

          </a>

        }


        <!-- LOGOUT -->

        @if (isLoggedIn()) {

          <a
            mat-list-item
            (click)="logout(drawer)"
          >

            <mat-icon matListItemIcon>
              logout
            </mat-icon>

            <span matListItemTitle class="item">
              {{ 'common.logout' | translate }}
            </span>

          </a>

        }

      </mat-nav-list>

    </mat-sidenav>


    <!-- ===================================================== -->
    <!-- MAIN CONTENT -->
    <!-- ===================================================== -->

    <mat-sidenav-content>

      <!-- =================================================== -->
      <!-- TOOLBAR -->
      <!-- =================================================== -->

      <mat-toolbar class="nav-toolbar">


        <!-- MOBILE MENU -->

        @if (isMobile()) {

          <button
            type="button"
            mat-icon-button
            class="menu-button"
            [attr.aria-label]="
              'nav.toggleNavigation' | translate
            "
            (click)="drawer.toggle()"
          >

            <mat-icon>
              menu
            </mat-icon>

          </button>

        }


        <!-- MOBILE BRAND -->

        @if (isMobile()) {

          <div
            class="brand"
          >
<img src="assets/images/logoo.png" alt="Logo" />
        </div>
  <!-- LANGUAGE -->
  <span class="spacer"></span>
            <button
              mat-button
              class="language-button"
              type="button"
              (click)="toggleLanguage()"
              [attr.aria-label]="
                'common.changeLanguage' | translate
              "
            >

             

              {{
                currentLanguage() === 'en'
                  ? 'العربية'
                  : 'English'
              }}

            </button>
        }


        <span class="spacer"></span>


        <!-- ================================================= -->
        <!-- ACTIONS -->
        <!-- ================================================= -->

        <div class="nav-actions">

          @if (!isMobile()) {



            <!-- LANGUAGE -->

            <button
              mat-button
              class="language-button"
              type="button"
              (click)="toggleLanguage()"
              [attr.aria-label]="
                'common.changeLanguage' | translate
              "
            >

              <mat-icon>
                translate
              </mat-icon>

              {{
                currentLanguage() === 'en'
                  ? 'العربية'
                  : 'English'
              }}

            </button>



            <!-- LOGIN -->

            @if (!isLoggedIn()) {

              <button
                mat-button
                routerLink="/login"
                class="login-button"
              >

                {{ 'common.login' | translate }}

              </button>

            }


            <!-- LOGOUT -->

            @if (isLoggedIn()) {

              <button
                mat-button
                class="logout-button"
                type="button"
                (click)="logout(drawer)"
              >

                <mat-icon>
                  logout
                </mat-icon>

                {{ 'common.logout' | translate }}

              </button>

            }

          }

        </div>

      </mat-toolbar>


      <!-- =================================================== -->
      <!-- CHILD PAGE -->
      <!-- =================================================== -->

      <main class="page-content">

  <div class="page-container">

    <router-outlet></router-outlet>

  </div>

</main>

    </mat-sidenav-content>

  </mat-sidenav-container>

</div>